/*
* Index
*/
module.exports = require('./lib/string-to-json.js');